export const xs = 0;
export const sm = 1024;
export const md = 1440;
export const lg = 1920;
export const xl = 1800;

export const xsPx = `${xs}px`;
export const smPx = `${sm}px`;
export const mdPx = `${md}px`;
export const lgPx = `${lg}px`;
export const xlPx = `${xl}px`;

export const sidebarWidth = 224;
export const sidebarWidthPx = '224px';
export const topNavHeight = 128;
export const topNavHeightPx = '128px';

export const appGridSmBreakpoint = '493px';
export const appGridMdBreakpoint = '953px';
export const appGridLgBreakpoint = '1216px';
